import MultiRangePrice from "@components/common/requestQuote/MultiRangePrice";
import { useFormContext } from "react-hook-form";

interface IInputBudget {
  label: string;
  sublabel?: string;
  hasAsterisk?: boolean;
}

const InputBudget = ({
  label,
  sublabel,
  hasAsterisk,
}: IInputBudget): JSX.Element => {
  const formContext = useFormContext();

  const RaQValueHandler = (budgets: { min: number; max: number }): void => {
    formContext.setValue("budgets", budgets);
  };
  return (
    <div className="flex h-fit flex-col gap-3">
      <p className="text-p">
        {label}
        {hasAsterisk ? "*" : ""}
      </p>
      {sublabel && (
        <span className="mb-1 text-p14 text-darkgray">{sublabel}</span>
      )}
      <MultiRangePrice setRaQValue={RaQValueHandler} />
    </div>
  );
};

export default InputBudget;
